(() => {
  const DAY_MS = 86400000;

  // Whole days from today (in the shop's time zone) to the deadline date, inclusive of the deadline day.
  function daysUntil(deadline, timeZone) {
    const today = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    return Math.round((Date.parse(`${deadline}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / DAY_MS);
  }

  function renderCountdowns(root) {
    root.querySelectorAll('[data-hol-deadline]').forEach((el) => {
      const deadline = el.dataset.holDeadline;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(deadline)) return;
      let days;
      try {
        days = daysUntil(deadline, el.dataset.holTz || 'America/Chicago');
      } catch (error) {
        return;
      }
      if (days > 1) el.textContent = `${days} days left`;
      else if (days === 1) el.textContent = 'Last day is tomorrow';
      else if (days === 0) el.textContent = 'Last day to order';
      else el.textContent = '';
    });
  }

  function bindSteppers(root) {
    root.querySelectorAll('[data-hol-qty]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      wrap.querySelectorAll('button[data-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const next = (parseInt(input.value, 10) || 1) + Number(button.dataset.step);
          input.value = Math.max(1, Math.min(next, 99));
        });
      });
    });
  }

  function bindCopy(root) {
    root.querySelectorAll('[data-hol-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const label = button.querySelector('[data-hol-copy-label]');
        try {
          await navigator.clipboard.writeText(button.dataset.holCopy);
          if (label) label.textContent = 'Copied';
        } catch (error) {
          if (label) label.textContent = 'Use at checkout';
        }
      });
    });
  }

  function bindFilms(root) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('.hol-film__frame').forEach((frame) => {
      const video = frame.querySelector('video');
      const button = frame.querySelector('[data-hol-sound]');
      if (!video) return;
      if (reduceMotion) {
        video.pause();
        video.controls = true;
      }
      if (!button) return;
      button.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted) video.play().catch(() => {});
        button.setAttribute('aria-pressed', String(!video.muted));
        button.querySelector('[data-hol-sound-label]').textContent = video.muted ? 'Sound on' : 'Sound off';
      });
    });
  }

  function revealOnScroll(root) {
    const targets = root.querySelectorAll('[data-hol-reveal]');
    if (!targets.length || !('IntersectionObserver' in window)) return;
    root.classList.add('is-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach((target) => observer.observe(target));
  }

  function init() {
    document.querySelectorAll('.hol').forEach((root) => {
      if (root.dataset.holBound) return;
      root.dataset.holBound = 'true';
      renderCountdowns(root);
      bindSteppers(root);
      bindCopy(root);
      bindFilms(root);
      if (!window.Shopify || !window.Shopify.designMode) revealOnScroll(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
